import { render, staticRenderFns } from "./BmLoader.vue?vue&type=template&id=d4bd36ec&scoped=true&"
import script from "./BmLoader.vue?vue&type=script&lang=js&"
export * from "./BmLoader.vue?vue&type=script&lang=js&"
import style0 from "./BmLoader.vue?vue&type=style&index=0&id=d4bd36ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bd36ec",
  null
  
)

export default component.exports